import { render, staticRenderFns } from "./CreateScanOrder.vue?vue&type=template&id=41d2450b&scoped=true"
import script from "./CreateScanOrder.vue?vue&type=script&lang=js"
export * from "./CreateScanOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateScanOrder.vue?vue&type=style&index=0&id=41d2450b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d2450b",
  null
  
)

export default component.exports